import { createCapabilitiesSelector } from 'moet-core';

import { NAME } from '../constants';

export default createCapabilitiesSelector(NAME);
